class ValidationForm extends HTMLElement {
  errorClass = 'text-red';
  validationMessages = {
    required: this.dataset.errorRequired,
    email: this.dataset.errorValidEmail,
  };
  constructor() {
    super();

    this.fieldsToValidate = this.querySelectorAll('[data-constraints]');
    this.querySelector('[submit]').addEventListener('click', this.onSubmit.bind(this));
  }
  onSubmit(event) {
    let focusOnError = false;

    this.fieldsToValidate.forEach((field) => {
      let constraints = field.dataset.constraints.split(' ');
      for (const constraint of constraints) {
        if (!!this.check[constraint]) {
          if (this.check[constraint](field)) {
            this.removeError(field);
          } else {
            if (!focusOnError) {
              focusOnError = field.previousElementSibling;
            }
            this.addError(constraint, field);
            event.preventDefault();
            break;
          }
        }
      }
    });

    if (focusOnError) {
      focusOnError.scrollIntoView();
    }
  }

  check = {
    required(field) {
      return field.value !== '';
    },
    email(field) {
      const emailRegex = /^[^@\s]+@[^@\s]+.[^@\s]+$/;
      return emailRegex.test(field.value);
    },
  };

  addError(type, field) {
    this.removeError(field);
    field.insertAdjacentHTML(
      'afterend',
      `<p class="${this.errorClass} text-xs uppercase">${this.validationMessages[type]}</p>`,
    );
  }

  removeError(field) {
    field.parentElement.querySelector(`.${this.errorClass}`)?.remove();
  }
}

customElements.define('validation-form', ValidationForm);
